


export enum RelationType {
    Instantiate,
    Dependency,
    Inheritance
}